import { Alert, Button, Checkbox, Radio } from "antd";
import React, { useRef, useState } from "react";
import useStore from "../store/useStore";

const publisheroptions = [
  {
    label: "천재",
    value: "CJ",
  },
  {
    label: "대교",
    value: "DK",
  },
  {
    label: "동아",
    value: "DA",
  },
  {
    label: "YBM 최",
    value: "YBMC",
  },
  {
    label: "YBM 김",
    value: "YBMK",
  },
];

const gradeoptions = [
  {
    label: "5학년",
    value: 5,
  },
  {
    label: "6학년",
    value: 6,
  },
];

const unitOptions = [
  { label: "1단원", value: "1" },
  { label: "2단원", value: "2" },
  { label: "3단원", value: "3" },
  { label: "4단원", value: "4" },
  { label: "5단원", value: "5" },
  { label: "6단원", value: "6" },
  { label: "7단원", value: "7" },
  { label: "8단원", value: "8" },
  { label: "9단원", value: "9" },
  { label: "10단원", value: "10" },
  { label: "11단원", value: "11" },
  { label: "12단원", value: "12" },
  { label: "13단원", value: "13" },
  { label: "14단원", value: "14" },
];

const WordFilterModal = ({ setFilterModalOpen }) => {
  const {
    selectedGrade,
    setSelectedGrade,
    selectedPublisher,
    setSelectedPublisher,
    selectedUnits,
    setSelectedUnits,
  } = useStore();

  const tempGrade = useRef(selectedGrade);
  const tempPublisher = useRef(selectedPublisher);
  const tempUnits = useRef(selectedUnits);

  const [filterType, setFilterType] = useState("all");
  const [filteredUnitOptions, setFilteredUnitOptions] = useState(unitOptions);
  const [selectedUnitsState, setSelectedUnitsState] = useState(tempUnits.current);

  const handleGradeChange = (checkedValues) => {
    tempGrade.current = checkedValues;
    // tempUnits.current = [];

    setSelectedUnitsState([]);
  };

  const onPublisherChange = (checkedValues) => {
    tempPublisher.current = checkedValues;
    // tempUnits.current = [];
    setSelectedUnitsState([]);

    let maxUnits;
    switch (checkedValues) {
      case "CJ":
        maxUnits = 11;
        break;
      case "DK":
      case "DA":
        maxUnits = 12;
        break;
      case "YBMC":
        maxUnits = 13;
        break;
      case "YBMK":
        maxUnits = 14;
        break;
      default:
        maxUnits = 14;
    }

    setFilteredUnitOptions(
      unitOptions.filter((option) => parseInt(option.value) <= maxUnits)
    );
  };

  const handleApply = () => {
    setSelectedGrade(tempGrade.current);
    setSelectedPublisher(tempPublisher.current);
    setSelectedUnits(tempUnits.current);
    setFilterModalOpen(false);
  };

  return (
    <div>
      <p>* 학년과 교과서는 1개만 선택 가능합니다.</p>
      <p>* 단원은 복수 선택이 가능합니다.</p>
      <div className="py-5 text-left">
        <form
          value={filterType}
          onChange={(e) => setFilterType(e.target.value)}
          style={{ display: "flex", flexDirection: "column", gap: "20px" }}
        >
          <div>
            <div className="category-title">학년</div>
            <Radio.Group
              className="grid grid-cols-4 gap-2"
              options={gradeoptions}
              value={tempGrade.current}
              onChange={(e) => handleGradeChange(e.target.value)}
            >
              {gradeoptions.map((option) => (
                <div key={option.value} className="chip">
                  <Checkbox value={option.value}>{option.label}</Checkbox>
                </div>
              ))}
            </Radio.Group>
          </div>

          <div>
            <div className="category-title">교과서</div>
            <Radio.Group
              className="grid grid-cols-4 gap-2"
              options={publisheroptions}
              value={tempPublisher.current}
              onChange={(e) => onPublisherChange(e.target.value)}
            >
              {publisheroptions.map((option) => (
                <div key={option.value} className="chip">
                  <Checkbox value={option.value}>{option.label}</Checkbox>
                </div>
              ))}
            </Radio.Group>
          </div>

          <div>
            <div className="category-title">단원</div>
            <Checkbox.Group
              className="grid grid-cols-4 gap-2"
              options={filteredUnitOptions}
              value={selectedUnitsState}
              onChange={(checkedValues) => {
                setSelectedUnitsState(checkedValues);
                tempUnits.current = checkedValues;
              }}
            >
              {filteredUnitOptions.map((option) => (
                <div key={option.value}>
                  <Checkbox value={option.value}>{option.label}</Checkbox>
                </div>
              ))}
            </Checkbox.Group>
          </div>
        </form>

        {selectedUnitsState.length === 0 ? (
          <Alert
            className="text-center rounded-full text-[#FF5F5F] mt-[40px]"
            message="최소 1개 단원은 반드시 선택되어야 합니다."
            type="error"
          />
        ) : (
          <></>
        )}
      </div>

      <div className="w-full mt-[40px] items-center justify-between flex gap-4">
        <Button
          onClick={() => setFilterModalOpen(false)}
          className="w-[50%] p-6 text-[16px] rounded-lg "
        >
          닫기
        </Button>
        <Button
          className="w-[50%] p-6 text-[16px] rounded-lg"
          type="primary"
          onClick={handleApply}
          disabled={selectedUnitsState.length === 0}
        >
          적용
        </Button>
      </div>
    </div>
  );
};

export default WordFilterModal;
